import React, {Fragment} from 'react';
import Formatters from '../../shared/utils/Formatters';

import AlertItem from './AlertItem';
import EmptyState from './EmptyState';

export default function AlertsList({
  alerts,
  caption,
  onClickUpdateButton,
  onClickDeleteButton
}) {
  return (
    <Fragment>
      <div className="pageHeader">
        <h2 className="headline">{Formatters.upperCaseWords(caption)}</h2>
      </div>
      <div className="ds-cardList">
        {alerts.length === 0 && <EmptyState type={caption} />}
        {alerts.map(alert => {
          return (
            <AlertItem
              key={alert.id}
              onClickUpdateButton={onClickUpdateButton}
              onClickDeleteButton={onClickDeleteButton}
              {...alert}
            />
          );
        })}
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/features/alertsManager/components/AlertsList.js